import React from "react"
import { injectIntl } from "react-intl"
import { withRouter } from "react-router-dom"
import ReactTooltip, { Place } from "react-tooltip"
import Icon from "../../icon/icon.component"
import FeatureProtectionWrapperMain from "./featureProtectionWrapperMain.component"
import { messages, getMessage, handleClick } from "./helpers.jsx"
import { Intl } from "../../../state/helpers/IntlProps"

type OwnProps = {
    isProtected: boolean
    protectionRule: boolean
    accountFeatureKey: string
    actionName: string
    className: string
    tooltipPosition: Place
    children: JSX.Element
    showLock: boolean
    premium: boolean
    message: string
    callback: () => void
    onClose: () => void
    onClickProtected: () => void
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    intl: Intl
}

const SelectOptionWrapper = (props: OwnProps) => {
    const showLock = props.showLock ?? true
    const lockedItem = <div onClick={(e) => {
        handleClick(e, props, () => {
            return
        })
    }} key={"tooltip-container"} data-tip data-for={"selectOptionLock"}>

        <ReactTooltip
            place={props.tooltipPosition}
            className="selectOptionLock"
            id={"selectOptionLock"}
            type="warning"
            effect="solid"
            multiline={true}>
            {getMessage(props.message, props.intl.formatMessage(messages["update_subscription"]))}
        </ReactTooltip>
        {props.children} {showLock && <Icon value="lock" className="lock"/>}
    </div>

    const item = props.children
    return (<>
        <FeatureProtectionWrapperMain
            protectionRule={props.protectionRule}
            accountFeatureKey={props.accountFeatureKey}
            isProtected={props.isProtected ?? true}
            displayModal={false}
            premium={props.premium}
            lockedItem={lockedItem}
            message={props.message}
            item={item}
            callback={props.callback || function () {
                return
            }}
            onClickProtected={props.onClickProtected || function () {
                return
            }}
            onClick={props.onClick || function () {
                return
            }}
        >
        </FeatureProtectionWrapperMain>
    </>)


}

export default withRouter(injectIntl(SelectOptionWrapper))


// WEBPACK FOOTER //
// ./src/common/rich-text/feature-protection-wrappers/selectOptionWrapper.component.tsx